import { render } from "./TheWishlist.vue?vue&type=template&id=1311bc3f&scoped=true"
import script from "./TheWishlist.vue?vue&type=script&lang=js"
export * from "./TheWishlist.vue?vue&type=script&lang=js"

import "./TheWishlist.vue?vue&type=style&index=0&id=1311bc3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1311bc3f"]])

export default __exports__